import { render, staticRenderFns } from "./ParentKeywordsRank.vue?vue&type=template&id=0782da87"
import script from "./ParentKeywordsRank.vue?vue&type=script&lang=js"
export * from "./ParentKeywordsRank.vue?vue&type=script&lang=js"
import style0 from "./ParentKeywordsRank.vue?vue&type=style&index=0&id=0782da87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports